import { GitRef } from '../models/git-worker.model';
import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitForEachRefAction extends WorkerAction {
  type: GitAction.ForEachRef;
}

export class GitForEachRefActionError extends WorkerActionError {}

export async function GitForEachRefActionFn({ lg }: WorkerFnParams<GitForEachRefAction>): Promise<GitRef[]> {
  try {
    const output = lg.callAndCaptureOutput(['for-each-ref']);
    return extractRefs(output);
  } catch (err) {
    throw new GitForEachRefActionError(err);
  }
}

function extractRefs(forEachRefOutput: string): GitRef[] {
  if (!forEachRefOutput) {
    return [];
  }
  /**
   * d67e8f18bd1db3dd4aac7691912ced986a09d864 commit	refs/heads/ddd	refs/remotes/origin/ddd
   * 4a7cf187999ab971d9f4795d8378a204037d322f commit	refs/heads/main	refs/remotes/origin/main
   */
  return forEachRefOutput.split('\n').map((line) => {
    // extract sha, ref name and upstream name
    // sha commit	refName	upstreamName
    const parsedResult = /(.+) commit\t(.+)\t(.+)?/.exec(line)!;
    return {
      sha: parsedResult[1] ?? '',
      name: parsedResult[2] ?? '',
      upstream: parsedResult[3],
    };
  });
}
